import { getStore } from '../store/store';
import MailTipsCacheEntry from '../store/schema/MailTipsCacheEntry';
import { NestedMruCache } from 'owa-nested-mru-cache';

/**
 * Gets mailTips property from the composeStore
 */
export default function getMailTips(): NestedMruCache<MailTipsCacheEntry> {
    return getStore().mailTips;
}
